import { BookingStatus } from '@rematter/frontend-lib-api-client/grpc/trade/booking_pb';
import {
  LoadStatus,
  SalesItemLineType,
} from '@rematter/frontend-lib-api-client/grpc/trade/load_pb';
import { PurchaseOrderStatus } from '@rematter/frontend-lib-api-client/grpc/trade/purchase_order_pb';
import {
  SalesOrderStatus,
  SalesOrderType,
} from '@rematter/frontend-lib-api-client/grpc/trade/salesOrder_pb';
import { Unit } from '@rematter/frontend-lib-api-client/grpc/types_pb';

export const salesOrderTypeLabels: Record<SalesOrderType, string> = {
  [SalesOrderType.UNSPECIFIED]: 'Unspecified',
  [SalesOrderType.DOMESTIC]: 'Domestic',
  [SalesOrderType.INTERNATIONAL]: 'International',
};

export const salesOrderStatusLabels: Record<SalesOrderStatus, string> = {
  [SalesOrderStatus.UNSPECIFIED]: 'Unspecified',
  [SalesOrderStatus.DRAFT]: 'Draft',
  [SalesOrderStatus.VOIDED]: 'Voided',
  [SalesOrderStatus.OPEN]: 'Open',
  [SalesOrderStatus.FINISHED]: 'Finished',
};

export const bookingStatusLabels: Record<BookingStatus, string> = {
  [BookingStatus.UNSPECIFIED]: 'Unspecified',
  [BookingStatus.VOIDED]: 'Voided',
  [BookingStatus.DRAFT]: 'Draft',
  [BookingStatus.OPEN]: 'Open',
  [BookingStatus.SHIPPED]: 'Shipped',
  [BookingStatus.COMPLETED]: 'Completed',
};

export const loadStatusLabels: Record<LoadStatus, string> = {
  [LoadStatus.UNSPECIFIED]: 'Unspecified',
  [LoadStatus.PENDING]: 'Pending',
  [LoadStatus.RECONCILED]: 'Reconciled',
  [LoadStatus.SHIPPED]: 'Shipped',
  [LoadStatus.RECEIVED]: 'Received',
  [LoadStatus.UNASSIGNED]: 'Unassigned',
  [LoadStatus.VOIDED]: 'Voided',
};

export const salesItemLineTypeLabels: Record<SalesItemLineType, string> = {
  [SalesItemLineType.UNSPECIFIED]: 'Unspecified',
  [SalesItemLineType.RAW]: 'Raw',
  [SalesItemLineType.TAGGED]: 'Tagged',
};

export const purchaseOrderStatusLabels: Record<PurchaseOrderStatus, string> = {
  [PurchaseOrderStatus.UNSPECIFIED]: 'Unspecified',
  [PurchaseOrderStatus.DRAFT]: 'Draft',
  [PurchaseOrderStatus.VOIDED]: 'Voided',
  [PurchaseOrderStatus.OPEN]: 'Open',
  [PurchaseOrderStatus.CLOSED]: 'Closed',
};

export const unitLabels: Record<Unit, string> = {
  [Unit.UNSPECIFIED]: 'Unspecified',
  [Unit.POUNDS]: 'Pounds',
  [Unit.NET_TONS]: 'Net Tons',
  [Unit.GROSS_TONS]: 'Gross Tons',
  [Unit.KILOGRAMS]: 'Kilograms',
  [Unit.METRIC_TONS]: 'Metric Tons',
  [Unit.SHORT_TONS]: 'Short Tons',
  [Unit.EACH]: 'Each',
  [Unit.SHORT_HUNDREDWEIGHT]: 'Short Hundredweight',
  [Unit.LONG_HUNDREDWEIGHT]: 'Long Hundredweight',
  [Unit.METER]: 'Meter',
  [Unit.YARD]: 'Yard',
};
